import { render, staticRenderFns } from "./getToken.vue?vue&type=template&id=1ecfa1bc&scoped=true&"
import script from "./getToken.vue?vue&type=script&lang=js&"
export * from "./getToken.vue?vue&type=script&lang=js&"
import style0 from "./getToken.vue?vue&type=style&index=0&id=1ecfa1bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecfa1bc",
  null
  
)

export default component.exports